import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'

import { getCustomStylesById } from 'utils/appUtils'
import { updateCustomStyleEffect, updateCustomStyleEffectLocally, getCustomStyleClassName } from 'controllers/logic'
import { POSITION, ZOOM } from 'constants/stylePresetType'
import StyledOverlay from './overlay/StyledOverlay'


const Container = styled.div`
  position: fixed;
`

class ShopifyOverlay extends Component {
  constructor (props) {
    super(props)
    // console.log('ShopifyOverlay constructor')
    this.state = {
      rect: this.calcRect(),
      className: this.getClassName(props)
    }
    this.timerId = setInterval(this.updateRect, 30)
  }

  getClassName = (props) => {
    const { app, field, overlayInfo } = props
    return getCustomStyleClassName(app, field, overlayInfo.className)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      className: this.getClassName(nextProps)
    })
  }

  updatePositionLocallySimple = (position) => {
    const { dispatch, app } = this.props
    const { className } = this.state
    dispatch(updateCustomStyleEffectLocally(app, className, POSITION, position))
  }

  updatePositionLocally = _.throttle(this.updatePositionLocallySimple, 30)

  updatePosition = (position) => {
    const { dispatch, app } = this.props
    const { className } = this.state
    dispatch(updateCustomStyleEffect(app, className, POSITION, position))
  }

  getInitialZoom = () => {
    const { app } = this.props
    const { className } = this.state
    const customStyles = getCustomStylesById(app, className)
    if (customStyles[ZOOM]) return customStyles[ZOOM].zoom
    return 1
  }

  updateZoomLocally = (value) => {
    const { dispatch, app } = this.props
    const { className } = this.state
    dispatch(updateCustomStyleEffectLocally(app, className, ZOOM, value))
  }

  updateZoom = (value) => {
    const { dispatch, app } = this.props
    const { className } = this.state
    dispatch(updateCustomStyleEffect(app, className, ZOOM, value))
  }

  calcRect = () => {
    const { overlayInfo } = this.props
    let rect
    if ('overlayKey' in overlayInfo) {
      const key = overlayInfo.overlayKey
      const elt = document.getElementById(key)
      if (elt && 'getBoundingClientRect' in elt) {
        rect = elt.getBoundingClientRect()
      }
    }
    return rect
  }

  updateRect = () => {
    const newRect = this.calcRect()
    const { rect } = this.state
    if (!rect) {
      this.setState({ rect: newRect })
      return
    }
    if (newRect) {
      if (rect.width !== newRect.width || rect.height !== newRect.height || rect.top !== newRect.top || rect.left !== newRect.left) {
        this.setState({ rect: newRect })
      }
    }
  }

  componentWillUnmount () {
    clearInterval(this.timerId)
    this.updateRect = () => null
  }

  resetZoomPosition = () => {
    const { activeMenuConf } = this.state
    const { dispatch, app } = this.props
    dispatch(updateCustomStyleEffect(app, activeMenuConf.className, POSITION, null))
    dispatch(updateCustomStyleEffect(app, activeMenuConf.className, ZOOM, null))
  }

  getInitialPosition = () => {
    const { app } = this.props
    const { className } = this.state
    const customStyles = getCustomStylesById(app, className)
    const res = {x: 0, y: 0}
    if (customStyles[POSITION]) {
      res.x = customStyles[POSITION].x
      res.y = customStyles[POSITION].y
    }
    return res
  }

  render () {
    const { overlayInfo, visible } = this.props
    const { rect } = this.state
    if (!overlayInfo) return null
    if (overlayInfo.overlayStyle && rect && visible) {
      const style = {
        left: `${rect.left}px`,
        top: `${rect.top}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`
      }
      return (
        <Container
          id='overlay'
          style={style}
        >
          <StyledOverlay
            style={style}
            overlayStyle={overlayInfo.overlayStyle}
            transparent={false}
            resizeAnchorsVisible
            getInitialPosition={this.getInitialPosition}
            updatePositionLocallySimple={this.updatePositionLocallySimple}
            updatePosition={this.updatePosition}
            canMove={overlayInfo.canMove}
            canResize={overlayInfo.canResize}
            getInitialZoom={this.getInitialZoom}
            updateZoomLocally={this.updateZoomLocally}
            updateZoom={this.updateZoom}
          />
        </Container>
      )
    } else {
      return <div />
    }
  }

}

ShopifyOverlay.defaultProps = {
  visible: true
}

ShopifyOverlay.propTypes = {
  app: PropTypes.object.isRequired,
  overlayInfo: PropTypes.object.isRequired,
  visible: PropTypes.bool,
  field: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  location: state.location
})

export default connect(mapStateToProps)(ShopifyOverlay)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/ShopifyOverlay.js